import {
  List,
  Datagrid,
  TextField,
  EditButton,
  TopToolbar,
  CreateButton,
  FunctionField,
  ExportButton,
  TextInput,
  DateField,
} from 'react-admin';
import { Card, CardContent, Button, Box } from '@mui/material';
import DeleteWithConfirmButton from "../../../components/DeleteWithConfirmButton.tsx";

import { useNavigate } from 'react-router-dom';
import { useNotify, useRedirect, useRefresh } from 'react-admin';
import { BulkDeleteButton } from 'react-admin';

const CustomBulkActionButtons = () => (
  <>
    <BulkDeleteButton
      label="Delete Selected"

    />
  </>
);


const ListActions = () => {
  const refresh = useRefresh();
  const notify = useNotify();
  const redirect = useRedirect();
  const navigate = useNavigate();
  return (
    <TopToolbar sx={{ marginBottom: '16px', }}>



      <CreateButton label="New Actions" sx={{
        top: '-5px', '& span': {

          marginRight: '2px',
        }
      }} />
    </TopToolbar>
  );
};

const ActionButtons = ({ record }: { record?: any }) => {
  const navigate = useNavigate();
  if (!record) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', width: '100%' }}>
      <EditButton record={record} sx={{
        textTransform: 'capitalize', '& span': {

          marginRight: '2px',

        }
      }} />
      <DeleteWithConfirmButton record={record} resource="permissionActions" />
    </div>
  );
};
const ActionList = (props: any) => (

  <List
    sx={{ marginTop: '20px', padding: '0 16px' }}
    empty={false}

    {...props} actions={<ListActions />}>


    <Datagrid rowClick={false} isRowSelectable={() => true} bulkActionButtons={<BulkDeleteButton label="Batch Delete" />}

      sx={{

        '& .RaDatagrid-headerCell': {
          textAlign: 'center',
        },
        '& .RaDatagrid-rowCell': {
          textAlign: 'center',
        },
      }}>
      <TextField source="id" label="Menu Id" />
      <TextField source="menu.title" label="Menu Title" />

      <TextField source="actionName" label="ActionName" />
      <TextField source="actionCode" label="ActionCode" />



      <FunctionField label="Operations" render={record => <ActionButtons record={record} />} />

    </Datagrid>


  </List >
);

export default ActionList;
